import ComputerIcon from '@mui/icons-material/Computer';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import DeviceUnknownIcon from '@mui/icons-material/DeviceUnknown';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import RouterIcon from '@mui/icons-material/Router';
import TabletIcon from '@mui/icons-material/Tablet';
import TabletAndroidIcon from '@mui/icons-material/TabletAndroid';
import TvIcon from '@mui/icons-material/Tv';
import WatchIcon from '@mui/icons-material/Watch';

const style = { height: '100%', width: '100%' };

const DeviceIcons = [
    <DeviceUnknownIcon key={0} sx={style} />,
    <PhoneAndroidIcon key={1} sx={style} />,
    <PhoneIphoneIcon key={2} sx={style} />,
    <TabletAndroidIcon key={3} sx={style} />,
    <TabletIcon key={4} sx={style} />,
    <ComputerIcon key={5} sx={style} />,
    <DesktopMacIcon key={6} sx={style} />,
    <TvIcon key={7} sx={style} />,
    <HeadphonesIcon key={8} sx={style} />,
    <WatchIcon key={9} sx={style} />,
    <RouterIcon key={10} sx={style} />,
    <DevicesOtherIcon key={11} sx={style} />,
];

export default DeviceIcons;
